import { render, staticRenderFns } from "./EditObstetric.vue?vue&type=template&id=4b73ab34&scoped=true"
import script from "./EditObstetric.vue?vue&type=script&lang=js"
export * from "./EditObstetric.vue?vue&type=script&lang=js"
import style0 from "./EditObstetric.vue?vue&type=style&index=0&id=4b73ab34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b73ab34",
  null
  
)

export default component.exports